export default __webpack_public_path__ + "static/media/selling-thumb-v1.6dd1a922.jpg";